import { useEffect, useState } from "react";
import { uid } from "uid";
import { db } from "../pages/db";
import { ref, set } from "firebase/database";

function Index() {
  const [connectWithFriendModal, setConnectWithFriendModal] = useState(false);

  var item_value = sessionStorage.getItem("my_key");
  var my_name = sessionStorage.getItem("my_name");

  const [name, setName] = useState(my_name);

  useEffect(() => {
    if (item_value === null) {
      sessionStorage.setItem("my_key", uid());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [uuid, setUuid] = useState("");
  useEffect(() => {
    setUuid(uid());
  }, []);

  const arrays = [
    ["", "", "", "", "", ""],
    ["", "", "", "", "", ""],
    ["", "", "", "", "", ""],
    ["", "", "", "", "", ""],
    ["", "", "", "", "", ""],
  ];
  const buttons = [0, 0, 0, 0, 0, 0];

  const createNewGame = () => {
    set(ref(db, `/${uuid.toLowerCase()}`), {
      array: arrays,
      buttons: buttons,
      player: false,
      finished: false,
      replay: false,
      draw: false,
      playerOne: "",
      playerTwo: "",
      playerOneName: "",
      playerTwoName: "",
      playerOneScore: 0,
      playerTwoScore: 0,
      robotPlayer: false,
    }).then(() => goTo());
  };

  const createNewGameWithRobot = () => {
    set(ref(db, `/${uuid.toLowerCase()}`), {
      array: arrays,
      buttons: buttons,
      player: false,
      finished: false,
      replay: false,
      draw: false,
      playerOne: "",
      playerTwo: "Bot",
      playerOneName: "",
      playerTwoName: "Bot",
      playerOneScore: 0,
      playerTwoScore: 0,
      robotPlayer: true,
    }).then(() => goTo());
  };

  const goTo = () => {
    window.location.href = "/game/" + uuid.toLowerCase();
  };

  const goToFriend = (id) => {
    if (id !== "") {
      window.location.href = "/game/" + id.toLowerCase();
    }
  };
  const [uniqueId, setUniqueId] = useState("");

  const saveName = (e) => {
    if (my_name === null && e.target.name.value !== "") {
      sessionStorage.setItem("my_name", e.target.name.value);
      setName(e.target.name.value);
    }
  };

  return (
    <div className="w-full min-h-screen flex justify-center items-center bg-[url('/public/images/wood.jpg')]">
      <div className="flex min-h-screen items-center justify-center w-auto px-8 ">
        <div className="w-full h-auto text-lg font-semibold text-center border border-gray-100 rounded-xl bg-white px-8 py-6 shadow-black/20 shadow-xl">
          <p>Game rules</p>
          <p className="w-full mx-auto font-normal">
            Make 4 circles same and straight in row, column, or diagonal.
          </p>
          <div className="flex flex-col space-y-4">
            <button
              onClick={() => createNewGame()}
              className="py-4 px-6 mt-4 shadow-md rounded-lg hover:shadow-xl border-2 hover:bg-gray-100"
            >
              Create new game
            </button>
            <button
              onClick={() => setConnectWithFriendModal(true)}
              className="py-4 px-6 mt-4 shadow-md rounded-lg hover:shadow-xl border-2 hover:bg-gray-100"
            >
              Game already started
            </button>
            <button
              onClick={() => createNewGameWithRobot()}
              className="py-4 px-6 mt-4 shadow-md rounded-lg hover:shadow-xl border-2 hover:bg-gray-100"
            >
              Play with bot
            </button>
          </div>
        </div>
        <div
          className={`${
            connectWithFriendModal ? "absolute" : "hidden"
          } w-full h-screen px-8 z-10 top-0 bg-black/30 flex justify-center items-center`}
        >
          <div className="relative z-10 w-full md:w-1/3 flex flex-col items-center justify-center bg-white rounded-xl p-16 ">
            <input
              type="text"
              onChange={(e) => setUniqueId(e.target.value)}
              name="uniqueId"
              className="border outline-none focus:ring-2 ring-gray-300 px-4 py-2 rounded-lg"
              placeholder="Write unique game id"
              required
            />
            <button
              onClick={() => goToFriend(uniqueId)}
              className="border rounded-lg px-4 py-2 text-lg font-semibold mt-4 hover:bg-gray-100"
            >
              Get in
            </button>
            <button
              onClick={() => setConnectWithFriendModal(false)}
              className="absolute top-4 right-4 border rounded-lg px-4 py-2 text-lg font-semibold hover:bg-gray-100"
            >
              X
            </button>
          </div>
        </div>
        <div
          className={`${
            name === "" || name === undefined || name === null
              ? "absolute"
              : "hidden"
          } w-full h-screen px-8 z-10 top-0 bg-black/30 flex justify-center items-center`}
        >
          <form
            onSubmit={(e) => saveName(e)}
            className="relative z-10 w-full md:w-1/3 flex flex-col items-center justify-center bg-white rounded-xl p-16 "
          >
            <input
              type="text"
              name="name"
              className="border outline-none focus:ring-2 ring-gray-300 px-4 py-2 rounded-lg"
              placeholder="Write your nickname"
              required
            />
            <button
              type="submit"
              className="border rounded-lg px-4 py-2 text-lg font-semibold mt-4 hover:bg-gray-100"
            >
              Save
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Index;
